import { z } from 'zod';

export type UserTypeManagers = 'COORDENADOR_ESCOLA' | 'COORDENADOR_TURMA' | 'COORDENADOR_SAAS' | 'CORRETOR_SAAS';

export type UserTypeRedux = UserTypeManagers | 'ALUNO' | 'PROFESSOR' | 'ASSESSOR';

export type UserType = UserTypeRedux | 'SUPER_ADMIN' | 'ADMIN' | 'ALUNO_B2C';

export enum Partner {
  AULAPP_TECH = 16,
  DESCOMPLICA = 2,
  EVOLUCIONAL = 7,
  EVO_RED = 22,
  GRUPO_MARISTA = 23,
  KROTON = 21,
  PLURALL = 18,
  PLURALL_B2G = 25,
  RED1000_CALIBRAGEM = 28,
  SESI_B2G = 27,
  STOODI = 20,
  WR = 14,
}

export const authUserSchema = z.object({
  uuid: z.string(),
  jwtToken: z.string(),
  nome: z.string(),
  apelido: z.string().optional(),
  perfil: z.custom<UserType>(),
  indRespondePesquisa: z.boolean().optional(),
  alterarSenha: z.boolean().optional(),
  aceiteTermosUso: z.boolean().optional(),
  aceiteContrato: z.boolean().optional(),
  escolaPlanoPrePago: z.boolean().optional(),
  exibeCompraCredito: z.boolean().optional(),
  possuiEscolaRed1000: z.boolean().optional(),
  parceiroId: z.number().optional(),
  indRespondePesquisaSatisfacao: z.boolean().optional(),
  parceiroIntegracao: z.boolean().optional(),
  validadeToken: z.string().optional(),
});

export type AuthUser = z.infer<typeof authUserSchema>;
